/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CenterBoxConsignment.vue?vue&type=template&id=717c8512&scoped=true"
import script from "./CenterBoxConsignment.vue?vue&type=script&lang=js"
export * from "./CenterBoxConsignment.vue?vue&type=script&lang=js"
import style0 from "./CenterBoxConsignment.vue?vue&type=style&index=0&id=717c8512&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717c8512",
  null
  
)

export default component.exports